import React from "react";

const RadioButtonsPep = ({ name, defaultValue, register }) => {
  return(
    <div className="wapperRadioButton check-sexo">
      <div className="wapperRadioButton__dolar">
        <label htmlFor={"si_" + name}>
          <input
            type="radio"
            name={name}
            id={"si_" + name}
            value="si"
            checked={defaultValue ? defaultValue === 'si' : null}
            ref={register}
          />
          <span>Sí</span>
        </label>
      </div>
      <div className="wapperRadioButton__soles">
        <label htmlFor={"no_" + name}>
          <input
            type="radio"
            name={name}
            id={"no_" + name}
            value="no"
            checked={defaultValue ? defaultValue === 'no' : null}
            ref={register}
          />
          <span>No</span>
        </label>
      </div>
    </div>
  );
};

export default RadioButtonsPep;